(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["consistency-stats-mobile"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function parse(raw) {
      var m = String(raw).match(/^(\D*)(\d+(?:[.,]\d+)?)(.*)$/);
      if (!m) return null;
      var numStr = m[2].replace(',', '.');
      var decimals = (numStr.split('.')[1] || '').length;
      return { prefix: m[1], target: parseFloat(numStr), suffix: m[3], decimals: decimals, raw: raw };
    }

    function animate(el) {
      var info = parse(el.getAttribute('data-countup'));
      if (!info) return;
      var duration = 1400;
      var startTime = null;
      function frame(now) {
        if (startTime === null) startTime = now;
        var p = Math.min((now - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
        var value = (info.target * eased).toFixed(info.decimals);
        el.textContent = info.prefix + value + info.suffix;
        if (p < 1) {
          requestAnimationFrame(frame);
        } else {
          el.textContent = info.raw;
        }
      }
      requestAnimationFrame(frame);
    }

    function init() {
      var nums = document.querySelectorAll('.cstat-mobile__num[data-countup]');
      if (!nums.length) return;

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) return; // leave final values

      nums.forEach(function (el) {
        if (el.dataset.countupReady) return;
        el.dataset.countupReady = '1';
        var info = parse(el.getAttribute('data-countup'));
        if (info) {
          el.textContent = info.prefix + (0).toFixed(info.decimals) + info.suffix;
        }
      });

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animate(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.4 });

      nums.forEach(function (el) { io.observe(el); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["creatine-compare-mobile"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function videoSrc(video) {
      if (!video) return '';
      var src = video.currentSrc || video.getAttribute('src');
      if (!src) {
        var source = video.querySelector('source');
        if (source) src = source.src;
      }
      return src ? src.split('#')[0] : '';
    }

    function init() {
      document.querySelectorAll('.cmp-mobile').forEach(function (section) {
        if (section.dataset.cmpInit) return;
        section.dataset.cmpInit = 'true';

        var card = section.querySelector('[data-cmp-card]');
        var modal = section.querySelector('[data-cmp-modal]');
        var modalVideo = modal ? modal.querySelector('.cmp-mobile__modal-video') : null;
        if (!card || !modal || !modalVideo) return;

        var tileVideo = card.querySelector('.cmp-mobile__video-el');
        var src = videoSrc(tileVideo);
        if (!src) return;

        function open() {
          modalVideo.src = src;
          modal.hidden = false;
          document.body.classList.add('cmp-modal-open');
          var p = modalVideo.play();
          if (p && p.catch) p.catch(function () {});
        }
        function close() {
          modalVideo.pause();
          modalVideo.removeAttribute('src');
          modalVideo.load();
          modal.hidden = true;
          document.body.classList.remove('cmp-modal-open');
        }

        card.addEventListener('click', open);
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            open();
          }
        });

        modal.querySelectorAll('[data-cmp-close]').forEach(function (el) {
          el.addEventListener('click', close);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !modal.hidden) close();
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cryo-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function splitLetters(el, letterClass) {
      if (el.dataset.lettersReady) return;
      el.dataset.lettersReady = '1';

      var text = el.textContent;
      var html = '';
      for (var i = 0; i < text.length; i++) {
        var ch = text[i];
        if (ch === '\n') {
          html += '<br>';
        } else if (ch === ' ') {
          html += ' ';
        } else {
          html += '<span class="' + letterClass + '">' + ch + '</span>';
        }
      }
      el.innerHTML = html;
    }

    function splitWords(link) {
      if (link.dataset.wordsReady) return;
      link.dataset.wordsReady = '1';

      var walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT, null);
      var textNodes = [];
      while (walker.nextNode()) textNodes.push(walker.currentNode);

      textNodes.forEach(function (node) {
        if (!node.nodeValue.trim()) return;

        var frag = document.createDocumentFragment();
        var parts = node.nodeValue.split(/(\s+)/);

        parts.forEach(function (part) {
          if (part === '') return;
          if (/^\s+$/.test(part)) {
            frag.appendChild(document.createTextNode(part));
            return;
          }
          var span = document.createElement('span');
          span.className = 'cryo-footer__link-word hover-highlight';
          span.textContent = part;
          frag.appendChild(span);
        });

        node.parentNode.replaceChild(frag, node);
      });
    }

    function updateFooterClock() {
      var now = new Date();
      var hh = String(now.getHours()).padStart(2, '0');
      var mm = String(now.getMinutes()).padStart(2, '0');

      document.querySelectorAll('[data-footer-clock-hh]').forEach(function (el) {
        el.textContent = hh;
      });
      document.querySelectorAll('[data-footer-clock-mm]').forEach(function (el) {
        el.textContent = mm;
      });
    }

    function initFooterClock() {
      if (!document.querySelector('[data-footer-clock]')) return;
      updateFooterClock();
      setInterval(function () {
        updateFooterClock();
        document.querySelectorAll('.cryo-footer__m-time-sep').forEach(function (el) {
          el.classList.toggle('is-blink-off');
        });
      }, 1000);
    }

    function initColorSchemeToggle() {
      var STORAGE_KEY = 'theme-color-scheme';
      var LIGHT_CLASS = 'color-scheme-3';
      var DARK_CLASS = 'color-scheme-a35d54e1-14af-438e-8a85-bb9de68b36c7';
      var MARKER = 'data-scheme-toggled';

      function applyScheme(dark) {
        document.documentElement.classList.toggle(DARK_CLASS, dark);

        if (dark) {
          document.querySelectorAll('.' + LIGHT_CLASS).forEach(function (el) {
            el.classList.remove(LIGHT_CLASS);
            el.classList.add(DARK_CLASS);
            el.setAttribute(MARKER, '1');
          });
        } else {
          document.querySelectorAll('[' + MARKER + ']').forEach(function (el) {
            el.classList.remove(DARK_CLASS);
            el.classList.add(LIGHT_CLASS);
            el.removeAttribute(MARKER);
          });
        }

        // .menu-drawer sits on its own GPU-composited layer (transform +
        // backdrop-filter), which some browsers fail to repaint when only an
        // *inherited* custom property changes on <html>. Set the variables
        // directly on the drawer itself so it always gets a real style change.
        var rootStyle = getComputedStyle(document.documentElement);
        var bg = rootStyle.getPropertyValue('--color-background');
        var fg = rootStyle.getPropertyValue('--color-foreground');
        document.querySelectorAll('.menu-drawer').forEach(function (el) {
          el.style.setProperty('--color-background', bg);
          el.style.setProperty('--color-foreground', fg);
        });
      }

      var isDark = false;
      try {
        isDark = localStorage.getItem(STORAGE_KEY) === 'dark';
      } catch (e) {}
      applyScheme(isDark);

      // Sections like the header drawer hydrate client-side after initial
      // load (see assets/section-hydration.js), replacing their markup with
      // freshly server-rendered HTML that reverts to its default (light)
      // pinned color scheme. Re-apply the current scheme whenever the DOM
      // is patched so late-hydrating content picks it up too.
      var reapplyScheduled = false;
      function scheduleReapply() {
        if (reapplyScheduled) return;
        reapplyScheduled = true;
        requestAnimationFrame(function () {
          reapplyScheduled = false;
          applyScheme(isDark);
        });
      }
      new MutationObserver(scheduleReapply).observe(document.body, {
        childList: true,
        subtree: true,
      });

      var toggle = document.querySelector('[data-color-scheme-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', function () {
        isDark = !isDark;
        applyScheme(isDark);
        try {
          localStorage.setItem(STORAGE_KEY, isDark ? 'dark' : 'light');
        } catch (e) {}
      });
    }

    function init() {
      document.querySelectorAll('.cryo-footer__m-tagline').forEach(function (el) {
        splitLetters(el, 'cryo-footer__m-tagline-letter');
      });
      document.querySelectorAll('.cryo-footer__m-links a').forEach(splitWords);
      initFooterClock();
      initColorSchemeToggle();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
